import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { patientNamespace } from "@/store/modules/patient";

@Component({})
export default class Allergies extends Vue {
  @Getter("allergies", patientNamespace)
  allergies!: string;
}
